// from https://stackoverflow.com/a/4819886
/* eslint-disable */
const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}

export default isTouchDevice;
